import React from 'react';
import { POST_TYPE_DETAILS_MAP, POST_TYPE_IDS_ENUM } from '../../../constants/BrandedCommunity/Post.js';
import { classNames } from '../../../utils/common/styling.js';
import { styles } from './PostTypeSelector.styles.js';

var PostTypeSelector = function (_a) {
    var postTypeIdsToShowList = _a.postTypeIdsToShowList, onPostTypeClick = _a.onPostTypeClick, disablePostTypeClick = _a.disablePostTypeClick, postTypeId = _a.postTypeId, postMediaIsAdded = _a.postMediaIsAdded;
    return (React.createElement(React.Fragment, null, postTypeIdsToShowList.map(function (typeId) {
        if (!POST_TYPE_DETAILS_MAP[typeId])
            return null;
        var disabled = postMediaIsAdded &&
            typeId !== postTypeId &&
            (postTypeId === POST_TYPE_IDS_ENUM.DOCUMENT ||
                postTypeId === POST_TYPE_IDS_ENUM.IMAGE);
        var postTypeClickDisabled = disablePostTypeClick || disabled;
        return (React.createElement("span", { key: typeId, className: classNames(styles.postTypeOption, postTypeClickDisabled && styles["postTypeOption-disabled"]), onClick: function () {
                if (postTypeClickDisabled)
                    return;
                onPostTypeClick(typeId);
            } },
            POST_TYPE_DETAILS_MAP[typeId].svgIcon,
            React.createElement("span", { className: styles.postTypeOptionLabel }, POST_TYPE_DETAILS_MAP[typeId].label)));
    })));
};

export { PostTypeSelector as default };
//# sourceMappingURL=PostTypeSelector.js.map
